import RequirementsPage from "./RequirementsPage";

export default RequirementsPage